<script setup lang="ts">
import { computed, useTemplateRef } from "vue";

import { eventTarget } from "@/utils/dom/dom";

const props = defineProps<{
  modelValue: string;
  type: string;
  maxlength: number;
  noBorders?: boolean;
}>();
const emit = defineEmits<{ "update:modelValue": [value: string]; inputOnBlur: [value: string] }>();

const rootRef = useTemplateRef("root");

defineExpose({ blur: () => void rootRef.value?.blur() });

const inputValue = computed({
  get: () => props.modelValue,
  set(value: string) {
    emit("update:modelValue", value);
  },
});

function focused(e: FocusEvent) {
  const target = eventTarget<HTMLInputElement>(e);
  target.setSelectionRange(0, ("" + target.value).length);
}

function emitValOnBlur() {
  const val = rootRef.value?.value || "";
  emit("inputOnBlur", val);
}
</script>

<!-- eslint-disable vuejs-accessibility/form-control-has-label-->
<template>
  <input
    ref="root"
    v-bind="$attrs"
    v-model="inputValue"
    :type
    :maxlength
    class="base-board-input"
    :class="{ 'has-borders': !noBorders }"
    autocomplete="false"
    @focus="focused"
    @blur="emitValOnBlur"
  />
</template>

<style lang="scss" scoped>
@use "@/styles/font";
@use "@/styles/board";
@use "@/styles/variables/colors";

.base-board-input {
  cursor: initial;
  width: 100%;
  font-weight: font.$weight-semi-bold;

  &.has-borders {
    border: board.len(3px) solid colors.$border-subtle;
    border-radius: board.len(10px);
    height: 100%;
  }

  &:focus {
    border-color: colors.$border-focused;
  }
}
</style>
